<script setup>
import { useAuthStore } from "@/stores/auth";

const auth = useAuthStore();
</script>

<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1 class="text-h4 mb-4">Errigal Admin</h1>
        <p v-if="auth.user" class="text-body-1">
          Signed in as {{ auth.user.profile?.name || auth.user.profile?.email }}.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-card to="/weather" link>
          <v-card-title>Weather</v-card-title>
          <v-card-text>Review ingested Met Éireann readings.</v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card to="/trails" link>
          <v-card-title>Trails</v-card-title>
          <v-card-text>Manage trail status and closures.</v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card to="/carpark" link>
          <v-card-title>Car Park</v-card-title>
          <v-card-text>View reports and people counter history.</v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card to="/bookings" link>
          <v-card-title>Bookings</v-card-title>
          <v-card-text>Approve group visits and close unavailable dates.</v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card to="/documents" link>
          <v-card-title>Documents</v-card-title>
          <v-card-text>Upload and manage policies, guides, and masterplans.</v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card to="/safety" link>
          <v-card-title>Safety Page</v-card-title>
          <v-card-text>Edit the visitor safety reminders content.</v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card to="/erosion" link>
          <v-card-title>Erosion Page</v-card-title>
          <v-card-text>Edit the visitor erosion risk card content.</v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card to="/users" link>
          <v-card-title>Users</v-card-title>
          <v-card-text>Create users, assign roles, and remove access.</v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
